import {fromJson, URL_BASE_AUTH} from "../utils/helper.js";


class SiteModel {


    constructor() {

        this.id = null;
        this.site_acc_number = null;
        this.system_type_id = null;
        this.name = null;
        this.control_panel_model_id = null;
        this.client_company_id = null;
        this.billing_account_id = null;
        this.contract_name_id = null;
        this.sales_tax_rate_id = null;
        this.order_required = null;
        this.order_situation_id = null;
        this.inspection_group_id = null;
        this.suite_id = null;
        this.protected_area_id = null;
        this.building_id = null;
        this.control_station_id = null;
        this.tax_exempt = null;
        this.credit_status_id = null;
        this.panel_location = null;
        this.control_panel_password = null;
        this.salesperson_id = null;
        this.account_manager_id = null;
        this.zipcode = null;
        this.floor = null;
        this.street_address = null;
        this.city_id = null;
        this.state = null;
        this.cross_street = null;
        this.critical_info = null;
        this.notes = null;
        this.service_notes = null;
        this.inspection_notes = null;
        this.critical_site_info = null;
        this.service_ticket_notes = null;
        this.billing_notes = null;
        this.sales_notes = null;


    }


    static fromJson(object) {
        return fromJson((new SiteModel()), object);
    }

}

export default SiteModel;
